export const shortenWalletAddress = (
  address: string,
  prefixLength: number = 6,
  suffixLength: number = 4,
): string => {
  if (address.length <= prefixLength + suffixLength + 1) {
    return address;
  }
  return `${address.slice(0, prefixLength)}…${address.slice(-suffixLength)}`;
};
